import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import { StellarTheme } from '@lavu-pos/stellar';

const muiBreakpoint = 'sm';

export const ContactInfoDialog = styled(Dialog).attrs({
	classes: {
		paper: 'customPaper',
	},
})`
	.customPaper {
		padding: 0;
		margin: 11px auto 35px auto;
		max-width: 495px;
	}

	.closer {
		display: flex;
		justify-content: flex-end;
		padding: 20px 20px 0 0;
	}

	.close-icon {
		cursor: pointer;
	}

	.footer {
		margin-top: 44px;
	}

	.actions {
		display: flex;
	}
`;

export const DialogWrapper = styled.div`
	padding: 0 30px;
	${StellarTheme.breakpoints.up(muiBreakpoint)} {
		padding: 0 47px;
	}
`;

export const DialogTitle = styled.div`
	text-align: center;
	color: #333f4b;

	.title {
		font-size: 24px;
		text-decoration: none solid rgb(51, 63, 75);
		margin: 0 0 21px 0;
		font-weight: 600;
	}

	.subtitle {
		font-size: 16px;
		text-decoration: none solid rgb(51, 63, 75);
		line-height: 26px;
		letter-spacing: 0.5px;
	}

	#cp-font-semibold {
		font-weight: 600 !important;
	}
`;

export const DialogContent = styled.div`
	padding-top: 31px;
`;
